import createSvgIcon from '@material-ui/core/utils/createSvgIcon';

const MacBook = createSvgIcon(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
      clipRule="evenodd"
    />
  </svg>,
  'MacBook'
);

export default MacBook;


